// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1HmQM","col":"Table_col__3zmvG","fulfillmentStatus":"Table_fulfillmentStatus__2FrU0","emailCol":"Table_emailCol__iMwcY"};